import axios from 'axios';
import { apiURL } from './constants';

export async function resolvePublicInvoicePay(token) {
  return axios.get(`${apiURL}/api/pay/i/${token}/`, { params: { format: 'json' } });
}

export async function reconcilePaymentResult({
  token,
  checkoutId,
  sessionId,
  paymobOrderId,
  paymobTransactionId,
}) {
  return axios.post(`${apiURL}/api/pay/result/reconcile/`, {
    token,
    checkout_id: checkoutId,
    session_id: sessionId,
    paymob_order_id: paymobOrderId,
    paymob_transaction_id: paymobTransactionId,
  });
}
